import { Box, Paper, Typography } from '@mui/material';
import { ItemWithId } from 'ui/EasTable/types';
import { PaginationBlock } from 'ui/PaginationBlock';
import { PAGE_SIZE } from 'services/constants/env';
import { EasTable } from '../EasTable';
import { EasTableFilterPanel } from '../EasTableFilterPanel';
import { TEasTableWithFilterProps } from './types';
import { COLORS } from '../../services/constants/colors';
import { EasPagination } from '../EasPagination';

export const EasTableWithFilter = <T extends ItemWithId>({
	tableStructure,
	items,
	itemsIsLoading,
	handleAction,
	handleLink,
	skeletonRows,
	highlightedRow,
	disabledRowFn,
	children,
	filterChildren,
	filterChildrenToEnd,
	filterChildrenToStart,
	name,
	onTableStructureChange,
	emFilter = false,
}: TEasTableWithFilterProps<T>) => {
	return (
		<Box>
			<Paper
				sx={{
					overflowX: 'auto',
				}}
			>
				<Box sx={{ width: 'auto', minWidth: '400px' }}>
					<Box sx={{ borderRadius: '12px' }}>
						{children && (
							<Box
								sx={{
									backgroundColor: COLORS.BACKGROUND_SECONDARY,
									p: 0.5,
								}}
							>
								{children}
							</Box>
						)}
						{!!tableStructure.length &&
							(tableStructure.some((item) => item.filterable) ||
								tableStructure.some((item) => item.searchable) ||
								tableStructure.some((item) => item.separateFilter) ||
								filterChildren ||
								emFilter ||
								filterChildrenToEnd) && (
								<EasTableFilterPanel
									tableStructure={tableStructure}
									loading={itemsIsLoading}
									onTableStructureChange={onTableStructureChange}
									emFilter={emFilter}
									childrenToEnd={filterChildrenToEnd}
									childrenToStart={filterChildrenToStart}
								>
									{filterChildren}
								</EasTableFilterPanel>
							)}
						<EasTable<T>
							tableStructure={tableStructure}
							items={items?.data ?? []}
							itemsIsLoading={itemsIsLoading}
							handleAction={handleAction}
							handleLink={handleLink}
							skeletonRows={skeletonRows}
							highlightedRow={highlightedRow}
							disabledRowFn={disabledRowFn}
						/>
					</Box>
				</Box>
			</Paper>
			<EasPagination total={items?.totalCount ?? 0} isLoading={itemsIsLoading} />
			{/* <Box
				sx={{
					padding: '0 20px 20px 20px',
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				<PaginationBlock total={items?.totalCount ?? 0} isLoading={itemsIsLoading} />
				{!!items?.totalCount && (
					<Box
						sx={{
							pt: '20px',
							display: 'flex',
							flexDirection: 'row',
						}}
					>
						<Typography
							sx={{
								fontSize: '1rem',
								color: '#555',
							}}
						>
							{items?.totalCount ? `Total items: ` : ''}
						</Typography>
						&nbsp;
						<Typography
							sx={{
								fontSize: '1rem',
								fontWeight: 'bold',
								color: 'primary.main',
							}}
						>
							{items?.totalCount
								? `${new Intl.NumberFormat('en-EN', { style: 'decimal' }).format(items?.totalCount ?? 0)} `
								: 'No data found'}
						</Typography>
					</Box>
				)}
			</Box> */}
		</Box>
	);
};
